import { Bolt, PointOfSaleSharp, ReceiptLong } from '@mui/icons-material';
import { Box, Chip, Paper, Typography } from '@mui/material';
import React from 'react';
import Ventas from '../ventas/Ventas';

const Cajero = ({ store, setOptions, setChildHeader }) => {
	return (
		<Box
			display='flex'
			flexDirection='column'
			height='100%'
			sx={{
				background: 'linear-gradient(180deg, #f2f7ff 0%, #ffffff 24%)',
			}}
		>

			<Box flex={1} minHeight={0}>
				<Ventas
					store={store}
					setOptions={setOptions}
					setChildHeader={setChildHeader}
					cashierMode
				/>
			</Box>
		</Box>
	);
};

export default Cajero;
